import { useUpdateBillLineItem } from "@api/bill.api";
import { BillLineItem } from "@common/types/bill";
import { LineItemClassesCell } from "@components/lineItems/LineItemClassesCell";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo, useCallback } from "react";
import { useScope } from "@state/scopeContext.lib";

export const ClassesCell = memo(
    ({ row }: CellContext<ViewTableFeatures, BillLineItem, unknown>) => {
        const { workspaceId } = useScope();
        const updateBillLineItem = useUpdateBillLineItem();

        const handleClassesChange = useCallback(
            async (classIds: string[]) => {
                if (!workspaceId) {
                    return;
                }

                await updateBillLineItem.mutateAsync({
                    workspaceId,
                    lineItemId: row.original.id,
                    classIds,
                });
            },
            [workspaceId, updateBillLineItem, row.original.id],
        );

        return (
            <LineItemClassesCell
                lineItem={row.original}
                onUpdateClasses={handleClassesChange}
            />
        );
    },
);
ClassesCell.displayName = "ClassesCell";
